import React from 'react';
import LibrarySvg from '@/assets/icons/library.svg?react';

interface LibraryIconProps {
  className?: string;
  size?: number;
}

const LibraryIcon: React.FC<LibraryIconProps> = ({ className = "w-7 h-7", size }) => {
  return (
    <LibrarySvg
      className={className}
      width={size}
      height={size}
    />
  );
};

export default LibraryIcon;